import {Form, Modal,Steps,Card,Button,Row, Col, message} from "antd"
import {useHistory}from "react-router-dom"
import React, { useCallback, useEffect, useState } from "react";
import ReactQuill from "react-quill";
import DescriptionProjectService from "../../../../../services/DescriptionProject";

const {Item}=Form



export default function ProjectDescriptionForm(props) {
  const {setOpenModalVisible,openModal,requestDescriptionsProject,ProjectId,stateModal,descriptionProject}=props;
  const history= useHistory();
  const [fields, setfields] = useState({
    summaryExecutive:"",
    introduction:"",
    background:"",
    problem:"",
    studyObject:"",
    generalObjetive:"",
    specificObjetive:"",
    fieldAction:"",
    workPlan:"",
    characteristic:"",
    aspiredResult:"",
    expectedImpact:"",
  });
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [form]=Form.useForm()
  // const reactQuillRef = React.useRef();
  const [current, setCurrent] = useState(0);
  const [fieldsSaves, setfieldsSaves] = useState({
    summaryExecutive:"",
    introduction:"",
    background:"",
    problem:"",
    studyObject:"",
    generalObjetive:"",
    specificObjetive:"",
    fieldAction:"",
    workPlan:"",
    characteristic:"",
    aspiredResult:"",
    expectedImpact:"",
  });

  // const onChange = useCallback( (value) => {
  //   let centerData=fieldsSaves
  //   let dataForm= form.getFieldsValue()
  //   centerData={
  //     ...centerData,
  //     ...dataForm
  //   }
  //   setfieldsSaves(centerData)
  //   setfields(centerData)
  //   setCurrent(value);
  // });

  const handleCancel=()=>{
    setOpenModalVisible(false)
    if(descriptionProject!=null){
      loadingData(fields,descriptionProject)
    }
    setCurrent(0)
  }

    const onFinish=()=>{
    try {
      
      let descriptionData=fieldsSaves
      let dataForm=form.getFieldsValue();
      setConfirmLoading(true)
      descriptionData={
        ...descriptionData,
        ...dataForm,
        projectId:ProjectId,
      }

      if(stateModal){
        createDescriptionProject(descriptionData)
      }else{
        updateDescriptionProject(descriptionData,ProjectId)
      }
      
      } catch (error) {
        console.log(error)
      }

    }

    const createDescriptionProject=useCallback((descriptionData)=>{
      DescriptionProjectService.createDescriptionProject(descriptionData).then((res)=>{
        let {success}=res.data
        if(success){
          message.success("Se creo con exito las descripciones del proyecto")
          requestDescriptionsProject(true)
        }else{
          message.error("No se pudo crear las descripciones del proyecto")
        }
        setConfirmLoading(false);
        setOpenModalVisible(false)
      })
    })

    const updateDescriptionProject=useCallback((descriptionData,projectId)=>{
      DescriptionProjectService.updateDescriptionProject(projectId,descriptionData).then((res)=>{
        let {success}=res.data
        if(success){
          message.success("Se actualizo con exito las descripciones del proyecto")
          requestDescriptionsProject(true)
        }else{
          message.error("No se pudo actualizar las descripciones del proyecto")
        }
        setConfirmLoading(false);
        setOpenModalVisible(false)
      })
    })

    const prev = useCallback( () => {
      let centerData=fieldsSaves
        let dataForm= form.getFieldsValue()
        let key=Object.keys(dataForm)
        if(dataForm[key]!=null){
          centerData={
            ...centerData,
            ...dataForm
          }
          setfields(centerData)
          setfieldsSaves(centerData)
        }
        else{
          form.setFieldValue(key,centerData[key])
        }
        setCurrent(current - 1);
    });

    // const cancel=()=>{
    // history.goBack();
    // }

    const next =useCallback(()=> {
      try {
        let centerData=fieldsSaves
        let dataForm= form.getFieldsValue()
        let key=Object.keys(dataForm)
        console.log(key)
        console.log(dataForm)
        if(dataForm[key]!=null){
          centerData={
            ...centerData,
            ...dataForm
          }
          console.log(centerData)
          setfieldsSaves(centerData)
          setfields(centerData)
        }
        else{
          form.setFieldValue(key,centerData[key])
        }
        setCurrent(current + 1);
        
  
        } catch (error) {
          console.log(error)
        }
      })

      const projectSummaryExecutive=()=>{
        return (
          <>
          <Item
            preserve
            name="summaryExecutive"
            // label="Introducción"
            >
                <div>
                    <ReactQuill
                    key={"summaryExecutive1"}
                    value={fields.summaryExecutive || null} 
                    onChange={(value)=>form.setFieldValue("summaryExecutive",value)}
                    />
                </div>
            </Item>
          </>
      )
      }
    const projectIntroduction=()=>{
        return (
            <>
              <Item
              preserve
              name="introduction"
              // label="Introducción"
              >
                  <div>
                      <ReactQuill
                      key={"Introduction1"}
                      value={fields.introduction || null}
                      onChange={(value)=>form.setFieldValue("introduction",value)}
                      />
                  </div>
              </Item>
            </>
        )
    }
    const projectBackground=()=>{
        return (
            <>
            <Item
              preserve
              name="background"
              // label="Introducción"
              >
                  <div>
                      <ReactQuill
                      key={"background1"}
                      value={fields.background}
                      onChange={(value)=>form.setFieldValue("background",value)}
                      />
                  </div>
              </Item>
            </>
        )
    }
    const projectProblem=()=>{
      return (
        <>
        <Item
          preserve
          name="problem"
          // label="Introducción"
          >
              <div>
                  <ReactQuill
                  key={"problem1"}
                  value={fields.problem}
                  onChange={(value)=>form.setFieldValue("problem",value)}
                  />
              </div>
          </Item>
        </>
    )
    }
    const projectStudyObject=()=>{
      return (
        <>
        <Item
          preserve
          name="studyObject"
          // label="Introducción"
          >
              <div>
                  <ReactQuill
                  key={"studyObject1"}
                  value={fields.studyObject}
                  onChange={(value)=>form.setFieldValue("studyObject",value)}
                  />
              </div>
          </Item>
        </>
    )
    } 

    const projectGeneralObjetive=()=>{
      return (
        <>
        <Item
          preserve
          name="generalObjetive"
          // label="Introducción"
          >
              <div>
                  <ReactQuill
                  key={"generalObjetive1"}
                  value={fields.generalObjetive}
                  onChange={(value)=>form.setFieldValue("generalObjetive",value)}
                  />
              </div>
          </Item>
        </>
    )
    }
    const projectSpecificObjetive=()=>{
      return ( 
        <Item
          preserve
          name="specificObjetive"
          // label="Introducción"
          >
              <div>
                  <ReactQuill
                  key={"specificObjetive1"}
                  value={fields.specificObjetive}
                  onChange={(value)=>form.setFieldValue("specificObjetive",value)}
                  />
              </div>
          </Item>
      )
    }
    const projectFieldAction=()=>{
      return (
        <Item
          preserve
          name="fieldAction"
          // label="Introducción"
          >
              <div>
                  <ReactQuill
                  key={"fieldAction1"}
                  value={fields.fieldAction}
                  onChange={(value)=>form.setFieldValue("fieldAction",value)}
                  />
              </div>
          </Item>
      )
    }
    const projectWorkPlan=()=>{
      return (
        <Item
          preserve
          name="workPlan"
          // label="Introducción"
          >
              <div>
                  <ReactQuill
                  key={"workPlan1"}
                  value={fields.workPlan}
                  onChange={(value)=>form.setFieldValue("workPlan",value)}
                  />
              </div>
          </Item>
      )
    }
    const projectCharacteristic=()=>{
      return (
        <Item
          preserve
          name="characteristic"
          // label="Introducción"
          >
              <div>
                  <ReactQuill
                  key={"characteristic1"}
                  value={fields.characteristic}
                  onChange={(value)=>form.setFieldValue("characteristic",value)}
                  />
              </div>
          </Item>
      )
    }
    const projectAspiredResult=()=>{
      return (<Item
          preserve
          name="aspiredResult"
          // label="Introducción"
          >
              <div>
                  <ReactQuill
                  key={"aspiredResult1"}
                  value={fields.aspiredResult}
                  onChange={(value)=>form.setFieldValue("aspiredResult",value)}
                  />
              </div>
          </Item>)
    }
    const projectExpectedImpact=()=>{
      
      return (
        <Item
        preserve
        name="expectedImpact"
        // label="Introducción"
        >
            <div>
                <ReactQuill
                key={"expectedImpact1"}
                value={fields.expectedImpact}
                onChange={(value)=>form.setFieldValue("expectedImpact",value)}
                />
            </div>
        </Item>
      )
    }


    const items = [
        {
          title: 'Resumen ejecutivo',
          content: projectSummaryExecutive(),
        },
        {
          title: 'Introducción',
          content: projectIntroduction(),
        },
        {
          title: 'Antecedentes',
          content: projectBackground(),
        },
        {
          title: 'Caracterización del problema',
          content: projectProblem(),
        },
        {
          title: 'Objetivo de estudio',
          content: projectStudyObject(),
        },
        {
          title: 'Objetivo general',
          content: projectGeneralObjetive(),
        },
        {
          title: 'Objetivos específicos',
          content: projectSpecificObjetive(),
        },
        {
          title: 'Campo de acción',
          content: projectFieldAction(),
        },
        {
          title: 'Plan de trabajo',
          content: projectWorkPlan(),
        },
        {
          title: 'Características epistemológicas y metodológicas ',
          content: projectCharacteristic(),
        },
        {
          title: 'Resultados Aspirados',
          content: projectAspiredResult(),
        },
        {
          title: 'Impacto Esperado',
          content: projectExpectedImpact(),
        },
      ];
      const itemsL = items.map((item) => ({
        key: item.title,
        title: item.title,
      }));

    const loadingData=(list,data)=>{
      let response=fields
      Object.keys(list).map((key)=>{
        // response[key]=data[key]!=null?data[key]:""
        response[key]=data[key]

      })
      setfields(response)
      setfieldsSaves(response)
    }

    useEffect(()=>{
      if(descriptionProject!=null){
        loadingData(fields,descriptionProject)
      }
      setCurrent(0)
    },[descriptionProject])

    return(
        <>
        <Modal
        style={{
          top: 20,
        }}
        open={openModal}
        onCancel={()=>{setOpenModalVisible(false)}}
        onOk={()=>form.submit()}
        confirmLoading={confirmLoading}
        closable={false}
        footer={null}
        width={1000}
        >
          <Row>
            <Col span={6}>
              {/* <Steps direction="vertical" current={current} onChange={onChange} items={itemsL}/> */}
              <Steps 
              direction="vertical" 
              current={current} 
              items={itemsL}
              size="small"/>
            </Col>
            <Col span={18}>
            <Row style={{marginTop:20}} align={"end"}>
          {current > 0 && (
              <Button
              key={"btnPrev"}
                style={{
                  margin: '0 8px',
                }}
                onClick={() => prev()}
              >
                Anterior
              </Button>
            )}
            {current < items.length -1 && (
              <Button key={"btnNext"} type="submit" onClick={(e) => next(e)}>
                Siguiente
              </Button>
            )}
            {current === items.length-1 && (
              <Button key={"btnFinsih"}type="primary" onClick={() => form.submit()}>
                Finalizar
              </Button>
            )}
            {/* {current == 0 && ( */}
              <Button
              key={"btnCancel"}
                style={{
                  margin: '0 8px',
                }}
                onClick={() => handleCancel()}
              >
                Cancelar
              </Button>
            {/* )} */}
          </Row>
              <Card>
                <Form
                name="formDescription"
                form={form}
                onFinish={onFinish}
                > 
                {items[current].content}
                </Form>
              </Card>
            </Col>
          </Row>
          
        </Modal>
        </>
    )
    
}